var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { TooltipStructure } from '../components/TooltipStructure';
// Utils
import styled from 'styled-components';
export var StyledTooltip = styled(TooltipStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: fit-content;\n  height: fit-content;\n  cursor: ", ";\n\n  & > *:disabled {\n    pointer-events: none;\n    cursor: inherit;\n  }\n"], ["\n  display: inline-block;\n  width: fit-content;\n  height: fit-content;\n  cursor: ", ";\n\n  & > *:disabled {\n    pointer-events: none;\n    cursor: inherit;\n  }\n"])), function (_a) {
    var hasDisabledChildren = _a.hasDisabledChildren;
    return (hasDisabledChildren ? 'not-allowed' : 'auto');
});
var templateObject_1;
//# sourceMappingURL=StyledTooltip.js.map